var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationsAvatar = function SvgNotificationsAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "notifications-avatar_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".notifications-avatar_svg__st1{fill:#002e22}")), /*#__PURE__*/React.createElement("path", {
    d: "M256 0c141.4 0 256 114.6 256 256S397.4 512 256 512 0 397.4 0 256 114.6 0 256 0z",
    style: {
      fill: "#03d47c"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.6 197v-41.7H185.4v201.3h141.2V315h-89.3v-38.6h71.9v-42.7h-71.9V197h89.3z",
    className: "notifications-avatar_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.3 88.9c35.7 0 68.5 11.1 95.8 30 6.9 4.8 16.4 4.4 22.3-1.5 6.7-6.7 6.3-17.7-1.4-23.3-32.9-23.7-73.2-37.7-116.7-37.7-110.3 0-200 89.7-200 200 0 43.5 14 83.9 37.7 116.7 5.5 7.7 16.6 8.1 23.3 1.4 6-6 6.3-15.4 1.5-22.3-18.9-27.2-30-60.1-30-95.8.1-92.6 75-167.5 167.5-167.5zM421.3 143.4c-5.5-8-16.8-8.5-23.6-1.6-5.9 5.9-6.4 15.2-1.8 22.2 17.5 26.4 27.8 58.3 27.8 92.4 0 34.2-10.7 67.1-28.9 94.1-4.7 6.9-4.3 16.3 1.7 22.3 6.8 6.8 17.9 6.3 23.4-1.5 22.9-32.5 36.4-72.1 36.4-114.8s-12.9-81.1-35-113.1zM256.3 423.8c-34.1 0-66-10.4-92.4-27.8-7-4.6-16.3-4.1-22.2 1.8-6.8 6.8-6.3 18.1 1.6 23.6 32.2 22.1 71.1 35 113 35 42.1 0 82.2-13.5 114.8-36.4 7.8-5.5 8.3-16.7 1.5-23.4-5.9-5.9-15.3-6.3-22.3-1.6-26.7 18.1-59.1 28.8-94 28.8z",
    className: "notifications-avatar_svg__st1"
  })));
};
export default SvgNotificationsAvatar;